(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card"] && !Shopify.designMode) return;
  try {
    /**
 * Collection Card Staggered Animation
 * Simple intersection observer to trigger staggered animations
 */

function initCollectionCardAnimations() {
  const resourceLists = document.querySelectorAll('.resource-list');
  
  resourceLists.forEach(function(resourceList) {
    const animatedCards = resourceList.querySelectorAll('.collection-card--staggered-animation');
    
    if (animatedCards.length > 0) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Trigger staggered animation for each card
            animatedCards.forEach(function(card, index) {
              setTimeout(function() {
                card.classList.add('animate');
              }, index * 300); // 100ms delay between each card
            });
            
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.5,
        rootMargin: '0px 0px -100px 0px'
      });
      
      observer.observe(resourceList);
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionCardAnimations);
} else {
  initCollectionCardAnimations();
}

// Backup initialization on window load
window.addEventListener('load', initCollectionCardAnimations);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    /**
   * Group Block Staggered Animation
   * Simple intersection observer to trigger staggered animations for group blocks
   */

  function initGroupBlockAnimations() {
    const sections = document.querySelectorAll('.section');
    
    sections.forEach(function(section) {
      const animatedGroups = section.querySelectorAll('.group-block--staggered-animation');
      
      if (animatedGroups.length > 0) {
        const observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              // Trigger staggered animation for each group block
              animatedGroups.forEach(function(group, index) {
                setTimeout(function() {
                  group.classList.add('animate');
                }, index * 300); // 300ms delay between each group block
              });
              
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.3,
          rootMargin: '0px 0px -50px 0px'
        });
        
        observer.observe(section);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGroupBlockAnimations);
  } else {
    initGroupBlockAnimations();
  }

  // Backup initialization on window load
  window.addEventListener('load', initGroupBlockAnimations);
  } catch(e) { console.error(e); }
})();

})();
